"use strict";

export function feature_js_auto_submit(el) {
	el.filter(':checkbox,:radio,:button,a').on('click', function() { el.closest('form').submit(); });
	el.filter(':input').on('change', function() { el.closest('form').submit(); });
}